import { useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';
import { LoadingContext, M_StateActions, NavigateContext } from 'src/M_Components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import CurrencyConfig from './currencyConfig';
import CurrencyConfigCrud from './currencyConfigCrud';

export default function CurrencyPage({ roles, onCreateTab, toastMessages, handleTabClose }) {
    const ctx = useContext(LoadingContext);
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const { renameTab } = useContext(NavigateContext);
    const matches = useMediaQuery('(min-width:900px)');
    const M_State = useSelector((state) => state.StateKeyValue);
    const selectedTab = useSelector(s => s.StateKeyValue.find(o => o.key === 'selectedTab')?.value);
    const location = useLocation();

    const [menu, setMenu] = useState(1);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [id, setId] = useState(() => M_State.find(obj => obj.key === 'selectedTab')?.value || 'currency');

    const sessionKeys = ['menu', 'selectedCurrency', 'refresh'];

    //============================================================================================================
    // EFFECT
    // Rename the tab when the language changes
    //============================================================================================================
    useEffect(() => {
        if (!selectedTab) return;
        renameTab(String(selectedTab), t('Currencies'));
    }, [t, selectedTab]);

    //============================================================================================================
    // EFFECT
    // Restore session storage data when the component mounts
    //============================================================================================================
    useEffect(() => {
        const session = M_State.find(obj => obj.key === id)?.value; // Retrieve the session data for the current tab
        if (session) { // If session data exists
            const m = session.find(x => x.key === 'menu')?.value; // Get the menu value from session
            const currency = session.find(x => x.key === 'selectedCurrency')?.value; // Get the selected currency from session
            const ref = session.find(x => x.key === 'refresh')?.value; // Get the refresh value from session
            if (m) setMenu(m); // Set the menu state
            if (currency) setSelectedCurrency(currency); // Set the selected currency state
            if (ref !== undefined) setRefresh(ref); // Set the refresh state
        }
        setRefresh(r => !r); // Toggle refresh state to trigger re-render if no session data is found
    }, [location.pathname]);

    //============================================================================================================
    // EFFECT
    // Update the session storage data when the component unmounts
    //============================================================================================================
    useEffect(() => {
        if (!id) return;
        const values = { menu, selectedCurrency, refresh };
        const sessionData = sessionKeys.map(k => ({ key: k, value: values[k] }));
        dispatch(M_StateActions.addM_State({ key: id, value: sessionData }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, menu, selectedCurrency, refresh]);

    return (
        <div className="divGlobalSettings">
            <div style={matches ? { display: 'flex' } : {}}>
                <div className="settingsPageMainDiv">
                    <Routes>
                        <Route index element={
                            <CurrencyConfig // Currency configuration component that shows the list of currencies
                                roles={roles}
                                onCreateTab={onCreateTab}
                                toastMessages={toastMessages}
                                selectedCurrency={selectedCurrency}
                                setSelectedCurrency={setSelectedCurrency}
                                refresh={refresh}
                                setRefresh={setRefresh}
                            />
                        } />
                        <Route path='currencyConfigCrud' element={
                            <CurrencyConfigCrud // Currency configuration CRUD component for creating and editing currencies
                                handleTabClose={handleTabClose}
                                toastMessages={toastMessages}
                            />
                        } />
                    </Routes>
                </div>
            </div>
        </div>
    );
}
